import { useQuery } from '@tanstack/react-query';
import { scanApi } from '@/services/api';

export function useKeywords(limit = 100, days = 30) {
  return useQuery({
    queryKey: ['keywords', limit, days],
    queryFn: () => scanApi.getPopularKeywords(limit, days),
    staleTime: 5 * 60_000,
  });
}
